const MAIN_ASSET_PATTERN = /\/assets\/main\.[a-f0-9]+\.js/i;

interface WebReleaseUpdateControllerOptions {
  currentEntryAsset: string;
  fetchCurrentHtml(): Promise<string>;
  reload(): void;
}

export type WebReleaseUpdateCheckResult =
  | 'current'
  | 'reload'
  | 'unavailable';

export const extractWebEntryAsset = (html: string): string | undefined =>
  html.match(MAIN_ASSET_PATTERN)?.[0];

/**
 * Сравнивает загруженный entry bundle с текущим HTML production. Один общий
 * запрос не позволяет нескольким lifecycle-событиям запустить повторный reload.
 */
export const createWebReleaseUpdateController = ({
  currentEntryAsset,
  fetchCurrentHtml,
  reload,
}: WebReleaseUpdateControllerOptions) => {
  let checkInProgress: Promise<WebReleaseUpdateCheckResult> | undefined;
  let reloading = false;

  const check = async (): Promise<WebReleaseUpdateCheckResult> => {
    if (reloading) return 'reload';

    try {
      const currentHtml = await fetchCurrentHtml();
      const productionEntryAsset = extractWebEntryAsset(currentHtml);
      if (!productionEntryAsset) return 'unavailable';
      if (productionEntryAsset === currentEntryAsset) return 'current';

      reloading = true;
      reload();
      return 'reload';
    } catch {
      return 'unavailable';
    }
  };

  return (): Promise<WebReleaseUpdateCheckResult> => {
    if (!checkInProgress) {
      checkInProgress = check().finally(() => {
        checkInProgress = undefined;
      });
    }
    return checkInProgress;
  };
};
